<form (ngSubmit)="submit()" [formGroup]="form" class="flex flex-col gap-4">
  <h3>Editar identificación del plan</h3>

  <div class="rounded-lg bg-neutral-50 p-3 flex flex-col gap-1">
    <span class="cd-text-b4 text-neutral-500">Fechas del plan</span>
    <span class="cd-text-b3 text-neutral-700">La fecha de finalización solo puede modificarse por prórroga.</span>
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="plan-name">Nombre</label>
    <div class="input-icon">
      <input autocomplete="off" formControlName="name" id="plan-name" placeholder="Nombre del plan" type="text">
    </div>
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="plan-description">Descripción</label>
    <textarea formControlName="description" id="plan-description" placeholder="Descripción" rows="3"></textarea>
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="plan-goals">Objetivos</label>
    <textarea formControlName="goals" id="plan-goals" placeholder="Objetivos" rows="3"></textarea>
  </div>

  @if (errorMessage) {
    <span class="cd-text-b4 text-error-600">{{ errorMessage }}</span>
  }

  <div class="w-full flex flex-row items-center gap-3">
    <button [disabled]="isSubmitting" class="btn btn-primary" type="submit">
      {{ isSubmitting ? 'Guardando...' : 'Guardar' }}
    </button>
    <button (click)="close()" [disabled]="isSubmitting" class="btn btn-primary-soft" type="button">
      Cancelar
    </button>
  </div>
</form>
